<template>
    <div class="d-flex align-items-center">
        <font-awesome-icon
            :icon="statusIcon.icon"
            :class="statusIcon.className"
            fixed-width />
        <span class="ml-2">
            {{ $t('menu.subPage', {index: step.subIndex + 1, total: step.subTotal}) }}
        </span>
    </div>
</template>

<script>
import {STEP_STATUS, STEP_STATUS_ICON} from "@/util/menu/stepStatus";

export default {
    name: "MenuItemSubPage",
    props: {
        step: {
            type: Object,
            required: true
        },
        status: {
            type: String,
            default: STEP_STATUS.PENDING
        }
    },
    computed: {
        statusIcon() {
            return STEP_STATUS_ICON[this.status] || STEP_STATUS_ICON[STEP_STATUS.PENDING]
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
